import { useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import { useRemindersRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	getNotificationCenterUpcomingV2,
	type TimelineHorizonEnum,
	type TimelineResponseDTO,
	type UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { filterReminderItemsByRight } from "web_myplann/NotificationCenter/Utils/filterReminderItemsByRight";

const STALE_TIME_MS = 60_000;

interface UpcomingTimelineParams {
	horizon: TimelineHorizonEnum;
	type: UpcomingTimelineItemTypeFilterEnum;
}

export const useUpcomingTimelineQuery = (params: UpcomingTimelineParams) => {
	const hasRemindersRight = useRemindersRightOptional();

	return useQuery({
		queryKey: NotificationCenterKeys.upcoming(params.horizon, params.type),
		queryFn: processResponseQuery(() =>
			getNotificationCenterUpcomingV2(params.horizon, params.type),
		),
		staleTime: STALE_TIME_MS,
		select: (data: TimelineResponseDTO) =>
			filterReminderItemsByRight(data, hasRemindersRight),
	});
};
